import AssessmentReportTemplate from "app/features/reporting/templates/AssessmentReportTemplate";
import { View } from "ui/atoms/view";
import { useSingleFormHistoryQuery } from "app/services/api/formsApi";
import { useFormsWithOffline } from "app/features/offline/hooks/useFormsWithOffline";
import {
  FormEnums,
  FormTagTitles,
} from "app/services/api/types/forms/enums/FormEnums";
import { useRouter } from "expo-router";
import { SubmittedFormModel } from "app/services/api/types/forms/models/SubmittedFormModel";
import { AssessmentFormProvider } from "app/features/assessments/providers/AssessmentFormProvider";
import { Text } from "react-native";
import LoadingSpinner from "ui/atoms/spinner/LoadingSpinner";

interface Props {
  tag?: FormEnums;
  formId?: number;
  entryId?: number;
  entry?: SubmittedFormModel;
  backPath?: string;
  entriesAreVersioned?: boolean;
  isLoading?: boolean;
  onSubmit?: () => void;
}
export function AssessmentReportFillTemplate({
  formId,
  tag,
  entryId,
  entry,
  backPath,
  entriesAreVersioned,
  isLoading,
  onSubmit,
}: Props) {
  const router = useRouter();
  const { data } = useSingleFormHistoryQuery(
    {
      formEntryId: entryId!,
    },
    { skip: !entryId },
  );

  const entryData = entryId ? data : entry;

  const localFormId = formId || entryData?.form.id;

  const { data: forms, isFetching } = useFormsWithOffline({
    formId: localFormId,
    tag,
  });

  if (isLoading || isFetching) {
    return (
      <View className="flex-1 items-center justify-center">
        <LoadingSpinner />
      </View>
    );
  }

  if (!forms?.[0]) {
    return (
      <View className="flex-1 items-center justify-center">
        <Text className="text-lg font-bold mb-2">Form not found</Text>
        {tag ? (
          <Text>
            Please confirm that a form with tag{" "}
            <Text className="font-bold">{FormTagTitles[tag] || tag}</Text>{" "}
            exists
          </Text>
        ) : null}
      </View>
    );
  }

  return (
    <View className="resident-container">
      <AssessmentFormProvider
        assessmentModel={forms[0]}
        entryData={entryData}
        entriesAreVersioned={entriesAreVersioned}
        onSubmit={() => {
          if (backPath) router.navigate(backPath);
          if (onSubmit) onSubmit();
        }}
      >
        <AssessmentReportTemplate isFetching={isFetching} backPath={backPath} />
      </AssessmentFormProvider>
    </View>
  );
}
